import { Navigator } from "../../main_components/navigator.js";
import { Blog      } from "./view_blog_components.js";
import bloggerImg    from "../../images/BlogLogo.png";
import testImg       from "../../images/34479554_8123745.jpg";
import Styles        from "./view_blog.module.css";
export const BlogBody = ( props ) => {
    const { } = props;
    const { Body, Content } = Styles;
    const data = {
        blogMainHeader  : { bloggerImg: bloggerImg, bloggerName: "Paradox", blogLink: "/blogs/blog" },
        blogMainContent : { 
            blogMainContentHeader: { blogTitle: "PFT", blogTitleIcon: "bi bi-chat-left-text-fill", date: "2024/11/14"  },
            blogContent          : [
                {
                    captions : [  
                        { 
                            title: "Digital Transformation", 
                            text: "Digital transformation refers to the integration of digital technology into all areas of business, fundamentally changing how organizations operate and deliver value to customers. It also marks a cultural change, requiring organizations to continually challenge the status quo." 
                        },
                        { 
                            title: "Artificial Intelligence", 
                            text: "Artificial intelligence (AI) enables machines to mimic human intelligence, learning from experience, adjusting to new inputs, and performing human-like tasks. It includes various subsets like machine learning and deep learning, revolutionizing industries from healthcare to finance." 
                        },
                        { 
                            title: "Quantum Computing", 
                            text: "Quantum computing is an emerging technology that harnesses the laws of quantum mechanics to solve problems too complex for classical computers. Its potential applications span fields like cryptography, drug discovery, and complex simulations, promising unparalleled computational power." 
                        },
                        { 
                            title: "Sustainable Energy", 
                            text: "Sustainable energy focuses on using renewable sources like solar, wind, and hydroelectric power to meet energy needs without depleting resources. It's essential for reducing greenhouse gas emissions and combatting climate change, pushing us toward a greener future." 
                        },
                        { 
                            title: "Blockchain Technology", 
                            text: "Blockchain is a decentralized, distributed ledger technology that records transactions across many computers. It's the foundation of cryptocurrencies and has potential applications in supply chain management, voting systems, and secure data sharing." 
                        },
                        { 
                            title: "The Internet of Things (IoT)", 
                            text: "IoT refers to a network of physical devices—vehicles, home appliances, and more—that are connected to the internet, collecting and sharing data. This technology enables smart homes, improves logistics, and enhances industrial processes by providing real-time insights." 
                        },
                        { 
                            title: "Cybersecurity", 
                            text: "Cybersecurity involves protecting computer systems, networks, and data from cyber threats. With the rise in digital transformation, cybersecurity has become vital for safeguarding sensitive information against increasingly sophisticated cyber attacks." 
                        },
                        { 
                            title: "Augmented Reality (AR)", 
                            text: "Augmented Reality overlays digital information on the real world, enhancing the user experience by adding visual, auditory, or other sensory information to the physical environment. AR is used in gaming, education, and various professional applications." 
                        },
                        { 
                            title: "5G Connectivity", 
                            text: "5G is the fifth generation of mobile network technology, providing faster speeds, reduced latency, and increased connectivity. This next-gen network supports advancements in IoT, autonomous vehicles, and immersive media experiences like virtual reality." 
                        },
                        { 
                            title: "Climate Change Awareness", 
                            text: "Climate change awareness aims to educate and encourage individuals and organizations to take action against climate-related issues. Reducing carbon footprints, promoting renewable energy, and conserving natural resources are key components of this global effort." 
                        }
                    ],
                },
                {
                    headline : { icon: <i className="bi bi-person-fill"></i>, headlineText: "headline", headlineTheme: "#9c27b0", headlineLink: null },
                },
                {
                    code     : { codeText: "const bool love = true;", codeType: "c++", codeTheme: "#607d8b" },
                },
                {
                    image    : { imageSrc: testImg, imageTheme: "#f44336", imageLink: null },
                },
            ],

        },
        blogMainFooter: { rate: 22 }
    };
    return (
        <main className={ Body }>
            <Navigator page={ "Blogs" }/>
            <main className={ Content }>
                <Blog 
                    blogMainHeader  = { data.blogMainHeader  }
                    blogMainContent = { data.blogMainContent }
                    blogMainFooter  = { data.blogMainFooter  }
                />
            </main>
        </main>
    );
};